import  React from "react";
import {Container} from "shards-react";
import { connect } from "react-redux";
import { requestPremium } from "../../actions/premium.action";

class PremiumMarkup extends React.Component {

    constructor(props) {
        super(props);
        this.props.loadData();
    }
    render() {
        return (
            <Container fluid className="main-content-container px-4">
                {/*<Row noGutters className="page-header py-4">
                    <PageTitle title="Liste des markups utilisés" subtitle="markup" className="text-sm-left mb-3"/>
                </Row>
                <Row>
                    <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
                            <TableData
                                research={this.props.premium}
                                tableData="patients"
                                dataColumns={[
                                    {
                                        Header: "Prénom",
                                        accessor: "firstname",
                                        className: "text-center",
                                        Cell: row => (
                                            <Link to={'/patients/' + row.original.id + '/profil'}>
                                                <div
                                                    className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                                />
                                                <span className="table__filter__practitioner">{row.original.first_name}</span>
                                            </Link>
                                        ),
                                    }, {
                                        Header: "Nom",
                                        accessor: "lastname",
                                        className: "text-center",
                                        Cell: row => (
                                            <Link to={'/patients/' + row.original.id + '/profil'}>
                                                <div
                                                    className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                                />
                                                <span className="table__filter__practitioner">{row.original.last_name}</span>
                                            </Link>
                                        ),
                                    },
                                ]}
                                pageSize={20}
                                title={"Liste des patients"}
                                dataSearch={requestPremium}
                                dataName={'patients'}
                            />
                        )}
                    </Col>
                </Row>*/}
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        premium: state['premium'],
    };
}

const mapDispatchToProps = dispatch => ({

    loadData: (e) => dispatch(requestPremium(e)),
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PremiumMarkup);



// WEBPACK FOOTER //
// ./src/views/Patients/PremiumMarkup.js